import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import SubHeader from '../../components/SubHeader/SubHeader';
import useResponsive from '../../hooks/useResponsive';
import { useTranslation } from 'react-i18next';
import styles from './SocialView.module.scss';
import StableHeader from '../StableView/StableHeader/StableHeader';
import Table from '../HorseView/TableRace/Table';
import HorseBox from '../HorseView/HorseDetails/HorseBox/HorseBox';
import DashBoard from '../../components/DashBoard/DashBoard';
import { ReactComponent as CancelIcon } from '../../assets/icons/cancel-icon1.svg';
import { ReactComponent as Messages } from '../../assets/icons/messages-gold.svg';
import cn from 'classnames';
import { useAppDispatch, useAppSelector } from '../../store/reducers';
import { getFriends, setDeleteModal, SocialActionsName } from '../../store/reducers/Social/slice';
import Heading from '../../components/Typography/Heading/Heading';
import SocialIcons from './SocialIcons/SocialIcons';
import DeleteFriendsModal from '../../components/Modals/DeleteFriendsModal/DeleteFriendsModal';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import ChatModal, { CHAT_MODAL_VIEWS } from '../../components/Modals/ChatModal/ChatModal';
import { setSocialStableNavigateBackRoute } from '../../store/reducers/Stable/slice';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import { displayName } from '../../components/LabelBox/LabelBox';
import { PROFILE_AVATARS } from '../../components/PhotoSelect/PhotoSelectData';
import { pickUserAvatar } from '../../components/PhotoSelect/PhotoSelect';
export const columns = [
    { label: 'avatar', accessor: 'avatar' },
    { label: 'name', accessor: 'name' },
    { label: 'status', accessor: 'status' },
    { label: 'Guild Name', accessor: 'guild_name' },
    { label: 'Prize money', accessor: 'prize_money' },
    { label: 'Ppr', accessor: 'ppr' },
    { label: 'Career', accessor: 'career' },
    { label: 'All-time ppr', accessor: 'all_time_ppr' },
    { label: 'season ppr', accessor: 'season_ppr' },
    { label: '', accessor: 'icons' }
];
export const ownerSocialIcons = [
    {
        value: _jsx(Messages, {}),
        name: 'messages'
    },
    // {
    //     value: <Cup />,
    //     name: 'cup'
    // },
    // {
    //     value: <Basket />,
    //     name: 'basket'
    // },
    {
        value: _jsx(CancelIcon, {}),
        name: 'cancel'
    }
];
export const memberSocialIcons = [
    {
        value: _jsx(Messages, {}),
        name: 'messages'
    }
    // {
    //     value: <Cup />,
    //     name: 'cup'
    // },
    // {
    //     value: <Basket />,
    //     name: 'basket'
    // }
];
export const memberGuildSocialIcons = [
// {
//     value: <Cup />,
//     name: 'cup'
// },
// {
//     value: <Basket />,
//     name: 'basket'
// }
];
const SocialView = () => {
    const isResponsive = useResponsive('xl');
    const { t } = useTranslation();
    const param = useParams();
    const dispatch = useAppDispatch();
    const { friends, pending } = useAppSelector((state) => state.social);
    const walletName = useAppSelector((state) => state.wallet.activeWallet.name);
    const { activeWallet } = useAppSelector((state) => state.wallet);
    const [deleteFriendsModal, setDeleteFriendsModal] = useState(false);
    const [user, setUser] = useState();
    const [searchFriendValue, setSearchFriendValue] = useState('');
    const navigate = useNavigate();
    const [messagesModal, setMessagesModal] = useState(false);
    const { pathname } = useLocation();
    const userId = useMemo(() => user === null || user === void 0 ? void 0 : user.id, [user]);
    const userName = useMemo(() => user === null || user === void 0 ? void 0 : user.address.slice(0, 10), [user]);
    const { stakeId } = param;
    const walletId = useMemo(() => (stakeId ? stakeId : walletName), [stakeId, walletName, activeWallet.address]);
    const iconsAction = {
        cancel: (data) => {
            setDeleteFriendsModal(true);
            setUser(data);
        },
        messages: (data) => {
            setUser(data);
            setMessagesModal(true);
        },
        cup: () => { },
        diamond: () => { },
        basket: () => { }
    };
    const handleIconClick = (name, data) => {
        iconsAction[name](data);
    };
    const makeMemberImage = (member) => {
        if (member.photo) {
            const path = pickUserAvatar(PROFILE_AVATARS[0].contents, member.photo);
            if (member.photo === 'logo') {
                return (_jsx("div", Object.assign({ onClick: () => navigate(`/stables/${member.address}/race`), className: "avatar" }, { children: _jsx(Logo, {}) })));
            }
            return (_jsx("div", Object.assign({ onClick: () => navigate(`/stables/${member.address}/race`), className: "avatar" }, { children: _jsx("img", { src: path, alt: "Avatar" }) })));
        }
        else {
            return (_jsx("div", Object.assign({ onClick: () => navigate(`/stables/${member.address}/race`), className: "avatar" }, { children: _jsx(Logo, {}) })));
        }
    };
    const friendsList = friends === null || friends === void 0 ? void 0 : friends.map((data) => {
        var _a;
        return (Object.assign(Object.assign({}, data), { avatar: makeMemberImage(data), name: displayName(data.name, data.address), guild_name: _jsx("p", { children: ((_a = data.guild) === null || _a === void 0 ? void 0 : _a.name) || '—' }) }));
    });
    const handleClick = (data) => {
        navigate(`/stables/${data.address}/race`);
    };
    useEffect(() => {
        //Saving the initial route for later navigating
        dispatch(setSocialStableNavigateBackRoute(pathname));
    }, []);
    useEffect(() => {
        dispatch(getFriends(searchFriendValue));
    }, [dispatch, searchFriendValue]);
    useEffect(() => {
        dispatch(getFriends(searchFriendValue));
    }, [dispatch, walletId, activeWallet.address]);
    return (_jsxs(_Fragment, { children: [pending.includes(SocialActionsName.GET_FRIENDS) ? (_jsx(Loader, {})) : (_jsxs("div", Object.assign({ className: styles.element }, { children: [!isResponsive && _jsx(SubHeader, { background: true, title: t('friends') }), _jsx(StableHeader, { searchInput: true, onChange: (value) => setSearchFriendValue(value), filters: false, onClick: () => { } }), _jsx(DashBoard, Object.assign({ className: styles.wrapper }, { children: _jsx(HorseBox, { children: friends && friends.length !== 0 ? (_jsx(Table, { onClick: handleClick, className: styles.table, columns: columns, tableData: friendsList, columnEnd: (data) => (_jsx(SocialIcons, { onClick: (name) => handleIconClick(name, data), icons: ownerSocialIcons })) })) : (_jsx("div", Object.assign({ className: 'd-flex align-items-center justify-content-center' }, { children: _jsx(Heading, { className: cn(styles.emptyListView), title: t('you_dont_have_any_connections') }) }))) }) }))] }))), deleteFriendsModal && (_jsx(DeleteFriendsModal, { userId: userId, closeModal: () => {
                    setDeleteFriendsModal(false);
                    dispatch(setDeleteModal(false));
                }, userName: (user === null || user === void 0 ? void 0 : user.name) || '' })), messagesModal && (_jsx(ChatModal, { singleChat: true, guildChat: false, memberId: userId, chatViews: CHAT_MODAL_VIEWS.CHAT_VIEW, closeModal: () => setMessagesModal(false) }))] }));
};
export default SocialView;
